import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {useTranslation} from 'react-i18next';

import {ScheduledSpot as ScheduledSpotService} from '../../services/scheduledSpotService';

import styles from './ScheduledSpotResultModal.scss';
import {Notification} from "../common";

export default function ScheduledSpotResultModal() {
    const { t } = useTranslation();
    const [scheduledSpotState, setScheduledSpotState] = useState(ScheduledSpotService.state);

    useEffect(() => {
        let done = false;
        let sub = ScheduledSpotService.subscribe(() => {
            if (!done) {
                setScheduledSpotState(ScheduledSpotService.state);
            }
        });
        return (() => {
            done = true;
            ScheduledSpotService.unsubscribe(sub);
        });
    }, []);

    const handleOk = () => {
        ScheduledSpotService.clearResult();
    };

    return (
        <Modal show={ScheduledSpotService.isConcluded()} onHide={handleOk} centered className="td-modal">
            {ScheduledSpotService.isScheduled() && (
                <>
                    <Notification content={t('td.fx.ticket.scheduledspot.result.scheduled.title')} style="success" icon="approved" padding="0" modal={true}/>
                    <Modal.Body className="td-modal-body-shown">
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                        <p className={styles.row}>{t('td.fx.ticket.scheduledspot.result.scheduled.submitted')}</p>
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                        <p className={styles.row}>
                            {t('td.fx.ticket.scheduledspot.result.scheduled.modifyWarning')}
                        </p>
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                        <p className={styles.row}>
                            {t('td.fx.ticket.scheduledspot.result.scheduled.funds')}
                        </p>
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                    </Modal.Body>
                    <Modal.Footer className={styles.resultFooter}>
                        <Button
                            className="btn td-btn-primary-light"
                            onClick={handleOk}
                        >
                            {t('td.fx.ticket.scheduledspot.result.ok')}
                        </Button>
                    </Modal.Footer>
                </>
            )}
            {ScheduledSpotService.isRejected() && (
                <>
                    <Notification content={t('td.fx.ticket.scheduledspot.result.rejected.title')} style="danger" icon="error" padding="0" modal={true}/>
                    <Modal.Body className="td-modal-body-shown">
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                        <p className={styles.row}>{t('td.fx.ticket.scheduledspot.result.rejected.message')}</p>
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                        <ul className={styles.errorList}>
                            {ScheduledSpotService.getErrors().map((error, index) => (
                                <li key={index} className={styles.errorItem}>{error}</li>
                            ))}
                        </ul>
                        <hr className="td-thin-divider-line-1" style={{ margin: '1em 0'}}/>
                    </Modal.Body>
                    <Modal.Footer className={styles.resultFooterRight}>
                        <Button
                            className="btn td-btn-primary-light"
                            onClick={handleOk}
                        >
                            {t('td.fx.ticket.scheduledspot.result.ok')}
                        </Button>
                    </Modal.Footer>
                </>
            )}
            {ScheduledSpotService.isTimedOut() && (
                <>
                    <Notification content={t('td.fx.ticket.scheduledspot.result.timeout.title')} style="danger" icon="error" padding="0" modal={true}/>
                    <Modal.Body>
                    </Modal.Body>
                    <Modal.Footer className={styles.resultFooterRight}>
                        <Button
                            className="btn td-btn-primary-light"
                            onClick={handleOk}
                        >
                            {t('td.fx.ticket.scheduledspot.result.ok')}
                        </Button>
                    </Modal.Footer>
                </>
            )}
        </Modal>
    );
}

